import { render, staticRenderFns } from "./three.vue?vue&type=template&id=35987d24&scoped=true"
import script from "./three.vue?vue&type=script&lang=js"
export * from "./three.vue?vue&type=script&lang=js"
import style0 from "./three.vue?vue&type=style&index=0&id=35987d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35987d24",
  null
  
)

export default component.exports